import styled from "styled-components";

export const ButtonDelete = styled.button`
  margin-left: 5px;
  padding: 0px 5px;
`;

export const ListField = styled.ul`
  list-style: none;
`;

export const ItemField = styled.li`
  display: flex;
  justify-content: space-between;
  padding: 5px 10px;
  border-bottom: 1px solid #ccc;
`;
